<template>
  <v-container class="12">
    <v-card outlined>
      <v-expansion-panels flat accordion focusable class="12">
        <v-expansion-panel class="12">
          <v-expansion-panel-header outlined class="12 flex justify-space-between justify-space-between">
            <div>
              {{ item.pageTitle }}
              <v-tooltip v-if="!item.pageConfig.landingPageTemplateSlug" bottom>
                <template #activator="{ on }">
                  <v-icon color="red" small v-on="on">error</v-icon>
                </template>
                <span>Missing URL</span>
              </v-tooltip>
            </div>
            <div class="d-flex justify-end mr-4">
              <v-tooltip max-width="300" bottom>
                <template #activator="{ on }">
                  <v-btn
                    title="Rename (quick edit)"
                    class="mr-4"
                    color="blue"
                    dark
                    depressed
                    v-on="on"
                    @click="onChangeShow(item)"
                    @click.stop
                  >
                    <v-icon small>drive_file_rename_outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit Nav item</span>
              </v-tooltip>
              <v-tooltip max-width="300" bottom>
                <template #activator="{ on }">
                  <v-btn color="red" class="light" light depressed v-on="on" @click.stop @click="onDelete">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete Nav item</span>
              </v-tooltip>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="12">
            <draggable v-model="item.subNavigationItems" @change="checkMove">
              <div
                class="mb-4 pt-4 12 d-flex align-center items-center flex justify-space-between justify-space-between"
              >
                <toggle-input v-model="item.isDynamicSubNavigation" label="Dynamic Subnavigation" />
                <v-btn
                  v-if="item.isDynamicSubNavigation"
                  title="Rename (quick edit)"
                  class="mr-4"
                  color="blue"
                  dark
                  depressed
                  @click="onChangeShowDynamic(item)"
                  @click.stop
                >
                  <v-icon small>drive_file_rename_outline</v-icon>
                </v-btn>
              </div>
              <div v-if="!item.isDynamicSubNavigation">
                <MenuItem
                  v-for="(child, index) in item.subNavigationItems"
                  :key="index"
                  :nav-index="index"
                  :item="child"
                  @deleteNav="onDeleteChild(index)"
                  @changeNav="onChangeChild($event, index)"
                  @updateNav="onUpdate($event, index)"
                  @orderNav="onUpdate($event, index)"
                />
              </div>
            </draggable>
            <v-card v-if="!item.isDynamicSubNavigation" flat class="ml-2 d-flex px-2 12 py-2 align-center justify-end">
              <row-create type="menu" create-text="Add Nav Sub Item" @click="onInsertShow" />
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <generic-modal
      v-model="editNavigationModalDynamic"
      hide-louis
      title="Edit Navigation"
      @modal-confirm="onChangeDynamic"
    >
      <div style="max-width: 400px">
        <span>Update name for </span>
        <span class="primary--text">{{ editedNav.pageTitle }}</span>
        <text-input v-model="editedNavUpdated.dynamicSubNavigationConfig.pageUrl" label="Page URL" />
        <select-list
          v-model="editedNavUpdated.dynamicSubNavigationConfig.landingPageTemplateSlug"
          :items="mappedPageTemplates"
          label="Landing Page"
          hide-details="auto"
        />
        <select-list
          v-model="editedNavUpdated.dynamicSubNavigationConfig.landingPageFunnelSlug"
          :items="mappedPageTemplates"
          class="mt-4"
          label="Funnel Page"
          hide-details="auto"
        />
        <select-list
          v-model="editedNavUpdated.dynamicSubNavigationConfig.coin"
          :items="coinOffers"
          class="mt-4"
          clearable
          label="Coin"
          hide-details
        />
        <select-list
          v-model="editedNavUpdated.dynamicSubNavigationConfig.stock"
          :items="stockOffers"
          class="mt-4"
          clearable
          label="Stock"
          hide-details
        />
        <text-input
          v-model="editedNavUpdated.dynamicSubNavigationConfig.limit"
          class="mt-4 mt-6"
          label="Limit"
          hide-details
          type="number"
        />
        <select-list
          v-model="editedNavUpdated.dynamicSubNavigationConfig.offerType"
          :items="getItemsForOption('offerTypes')"
          class="mt-4"
          label="Offer Types"
          hide-details
          outlined
        />
        <select-list
          v-model="editedNavUpdated.dynamicSubNavigationConfig.offers"
          :items="mappedOffers"
          class="mt-4"
          label="Specific Offers"
          hide-details
          multiple
        />
      </div>
    </generic-modal>
    <generic-modal v-model="editNavigationModalPage" hide-louis title="Edit Navigation" @modal-confirm="onChangePage">
      <div style="max-width: 400px">
        <span>Update name for </span>
        <span class="primary--text">{{ editedNav.pageTitle }}</span>
        <text-input v-model="editedNavUpdated.pageTitle" label="Page Title" class="mt-6" />
        <text-input v-model="editedNavUpdated.pageUrl" label="Page URL" />
        <toggle-input
          v-model="editedNavUpdated.includeInSitemap"
          :disabled="isLoading"
          class="mb-6"
          label="Include in Sitemap"
        />
        <toggle-input
          v-model="editedNavUpdated.includeInNavigation"
          :disabled="isLoading"
          class="mb-6"
          label="Include in Navigation"
        />
        <select-list
          v-model="editedNavUpdated.pageConfig.landingPageTemplateSlug"
          :items="mappedPageTemplates"
          label="Landing Page"
          hide-details="auto"
        />
        <select-list
          v-model="editedNavUpdated.pageConfig.landingPageFunnelSlug"
          :items="mappedPageTemplates"
          class="mt-4"
          label="Funnel Page"
          hide-details="auto"
        />
        <select-list
          v-model="editedNavUpdated.pageConfig.offerSlug"
          class="mt-4"
          :items="mappedOffers"
          label="Offer"
          hide-details
        />
        <select-list
          v-model="editedNavUpdated.pageConfig.coin"
          :items="coinOffers"
          class="mt-4"
          clearable
          label="Coin"
          hide-details
        />
        <select-list
          v-model="editedNavUpdated.pageConfig.stock"
          :items="stockOffers"
          class="mt-4"
          clearable
          label="Stock"
          hide-details
        />
      </div>
    </generic-modal>
    <generic-modal v-model="newNavigationModal" hide-louis title="New Navigation" @modal-confirm="onInsert">
      <div style="max-width: 400px">
        <text-input v-model="newNavigation.pageTitle" label="Page Title" />
        <text-input v-model="newNavigation.pageUrl" label="Page URL" />
        <toggle-input
          v-model="newNavigation.includeInSitemap"
          :disabled="isLoading"
          class="mb-6"
          label="Include in Sitemap"
        />
        <toggle-input
          v-model="newNavigation.includeInNavigation"
          :disabled="isLoading"
          class="mb-6"
          label="Include In Navigation"
        />
        <select-list
          v-model="newNavigation.pageConfig.landingPageTemplateSlug"
          :items="mappedPageTemplates"
          label="Landing Page"
          hide-details="auto"
        />
        <select-list
          v-model="newNavigation.pageConfig.landingPageFunnelSlug"
          :items="mappedPageTemplates"
          class="mt-4"
          label="Funnel Page"
          hide-details="auto"
        />
        <select-list
          v-model="newNavigation.pageConfig.offerSlug"
          :items="mappedOffers"
          class="mt-4"
          label="Offer"
          hide-details
        />
        <select-list
          v-model="newNavigation.pageConfig.coin"
          :items="coinOffers"
          class="mt-4"
          clearable
          label="Coin"
          hide-details
        />
        <select-list
          v-model="newNavigation.pageConfig.stock"
          :items="stockOffers"
          class="mt-4"
          clearable
          label="Stock"
          hide-details
        />
      </div>
    </generic-modal>
  </v-container>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash-es'
// Components
import Draggable from 'vuedraggable'
import RowCreate from '@/components/row-create'
import GenericModal from '@/components/modals/generic-modal'
import SelectList from '@/components/forms/select-list'
import ToggleInput from '@/components/forms/toggle-input'
import TextInput from '@/components/forms/text-input'
// Mixins
// Helpers
import { landingPages, offers } from '@/services/offers'

const blankNewPage = () => ({
  pageTitle: '',
  pageUrl: '',
  pageConfig: {
    landingPageFunnelSlug: '',
    landingPageTemplateSlug: '',
    language: false,
    offerSlug: false,
    coin: false,
    stock: false,
  },
  dynamicSubNavigationConfig: {
    landingPageFunnelSlug: '',
    landingPageTemplateSlug: '',
    coin: false,
    stock: false,
    limit: 0,
    offerType: '',
    offers: [],
  },
  includeInSitemap: false,
  includeInNavigation: false,
  isDynamicSubNavigation: false,
  subNavigationItems: [],
})

export default {
  name: 'MenuItem',
  components: {
    Draggable,
    GenericModal,
    TextInput,
    SelectList,
    ToggleInput,
    RowCreate,
  },
  props: {
    hasErrors: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    editNavigationModal: false,
    newNavigationModal: false,
    editNavigationModalDynamic: false,
    editNavigationModalPage: false,
    showDynamicEdit: false,
    showDynamicNew: false,
    newNavigation: blankNewPage(),
    editedNav: blankNewPage(),
    editedNavUpdated: blankNewPage(),
    pageTemplates: [],
    offers: [],
  }),
  computed: {
    ...mapGetters('general', ['hasPageErrors', 'isPageLoading']),
    ...mapGetters('options', ['options', 'formattedOption', 'getItemsForOption', 'hasOptions']),
    mappedPageTemplates() {
      return this.pageTemplates.map(({ slug, template: { default: { templateName } } }) => ({
        key: templateName || slug,
        value: slug,
      }))
    },
    mappedOffers() {
      return this.offers.map(({ slug, type, name }) => ({
        key: `${name || slug} (${this.formattedOption('offerTypes', type)})`,
        value: slug,
        type,
      }))
    },
    coinOffers() {
      return (this.options && this.options.entities && this.options.entities.cryptoCoin) || []
    },
    stockOffers() {
      return (this.options && this.options.entities && this.options.entities.tradingStock) || []
    },
  },
  async created() {
    await Promise.all([this.getLandingPageTemplates(), this.getOffers()])
  },
  methods: {
    async getLandingPageTemplates() {
      this.pageTemplates = await landingPages.getAllLandingPageTemplates()
    },
    async getOffers() {
      try {
        const { data } = await offers.getAllOffers({ compact: true })
        this.offers = data
      } catch (error) {
        this.setPageErrors(true)
        this.$notify({
          type: 'error',
          text: 'Unable to retrieve offers',
        })
      }
    },
    onDelete(index) {
      this.$emit('deleteNav')
    },
    onInsertShow() {
      this.newNavigationModal = true
    },
    onChangeShow(navigation) {
      this.editedNav = cloneDeep(navigation)
      this.editedNavUpdated = cloneDeep(navigation)
      // console.log(cloneDeep(navigation))
      this.editNavigationModalPage = true
    },
    onChangeShowDynamic(navigation) {
      this.editedNav = cloneDeep(navigation)
      this.editedNavUpdated = cloneDeep(navigation)
      this.editNavigationModalDynamic = true
    },
    onDeleteChild(index) {
      const subNavigationItems = this.item.subNavigationItems
        .slice(0, index)
        .concat(this.item.subNavigationItems.slice(index + 1))
      this.$emit('updateNav', { ...this.item, subNavigationItems })
    },
    onInsert() {
      this.onInsertChild()
      this.newNavigationModal = false
      this.newNavigation = blankNewPage()
    },
    onChange() {
      this.$emit('changeNav', this.editedNavUpdated)
      this.editNavigationModal = false
    },
    onChangeDynamic() {
      this.$emit('changeNav', this.editedNavUpdated)
      this.editNavigationModalDynamic = false
    },
    onChangePage() {
      this.$emit('changeNav', this.editedNavUpdated)
      this.editNavigationModalPage = false
    },
    onChangeChild(item, index) {
      const subNavigationItems = this.item.subNavigationItems
        .slice(0, index)
        .concat(item)
        .concat(this.item.subNavigationItems.slice(index + 1))
      this.$emit('updateNav', { ...this.item, subNavigationItems })
    },
    checkMove() {
      const subNavigationItems = this.item.subNavigationItems
      this.$emit('orderNav', { ...this.item, subNavigationItems })
    },
    onInsertChild() {
      const subNavigationItems = this.item.subNavigationItems
        ? this.item.subNavigationItems.concat(this.newNavigation)
        : [this.newNavigation]
      this.$emit('updateNav', { ...this.item, subNavigationItems })
    },
    onUpdate(child, index) {
      const subNavigationItems = this.item.subNavigationItems
        .slice(0, index)
        .concat(child)
        .concat(this.item.subNavigationItems.slice(index + 1))
      this.$emit('updateNav', { ...this.item, subNavigationItems })
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-item {
  position: relative;
}

.deal-banner {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 120px;
  border-top-left-radius: 8px;

  &.has-deal {
    cursor: help;
  }
}

.position {
  width: 2em;
}

.highlight-draft {
  border: 1px solid red !important;
}

.v-expansion-panel-content__wrap {
  padding: 0 0 0 0 !important;
}
</style>
